(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[900],{

/***/ 5109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(6345));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var ChevronRight=function ChevronRight(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M9 18l6-6-6-6"}))};var _default=ChevronRight;exports.Z=_default;

/***/ }),

/***/ 4993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MDXContext": function() { return /* binding */ MDXContext; },
/* harmony export */   "MDXProvider": function() { return /* binding */ MDXProvider; },
/* harmony export */   "mdx": function() { return /* binding */ createElement; },
/* harmony export */   "useMDXComponents": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "withMDXComponents": function() { return /* binding */ withMDXComponents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2983);


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var MDXContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var withMDXComponents = function withMDXComponents(Component) {
  return function (props) {
    var allComponents = useMDXComponents(props.components);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
      components: allComponents
    }));
  };
};
var useMDXComponents = function useMDXComponents(components) {
  var contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext);
  var allComponents = contextComponents;

  if (components) {
    allComponents = isFunction(components) ? components(contextComponents) : _objectSpread2(_objectSpread2({}, contextComponents), components);
  }

  return allComponents;
};
var MDXProvider = function MDXProvider(props) {
  var allComponents = useMDXComponents(props.components);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MDXContext.Provider, {
    value: allComponents
  }, props.children);
};

var TYPE_PROP_NAME = 'mdxType';
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}, children);
  }
};
var MDXCreateElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var propComponents = props.components,
      mdxType = props.mdxType,
      originalType = props.originalType,
      parentName = props.parentName,
      etc = _objectWithoutProperties(props, ["components", "mdxType", "originalType", "parentName"]);

  var components = useMDXComponents(propComponents);
  var type = mdxType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;

  if (propComponents) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2(_objectSpread2({
      ref: ref
    }, etc), {}, {
      components: propComponents
    }));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2({
    ref: ref
  }, etc));
});
MDXCreateElement.displayName = 'MDXCreateElement';
function createElement (type, props) {
  var args = arguments;
  var mdxType = props && props.mdxType;

  if (typeof type === 'string' || mdxType) {
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = MDXCreateElement;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps.originalType = type;
    newProps[TYPE_PROP_NAME] = typeof type === 'string' ? type : mdxType;
    createElementArgArray[1] = newProps;

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, args);
}




/***/ }),

/***/ 7424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(2983);
var MDX = __webpack_require__(4993);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MDX__namespace = /*#__PURE__*/_interopNamespace(MDX);

if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = React.useState(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    React.useEffect(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = React.useMemo(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ mdx: MDX__namespace.mdx, React: React__default['default'] }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}; return MDXContent;`));
        return hydrateFn.apply(hydrateFn, values);
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (React__default['default'].createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (React__default['default'].createElement(MDX__namespace.MDXProvider, { components: components },
        React__default['default'].createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? React__default['default'].createElement("div", null, content) : content;
}

exports.R = MDXRemote;


/***/ }),

/***/ 6380:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[[...slug]]",
      function () {
        return __webpack_require__(3820);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ Docs; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(4517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-mdx-remote@3.0.8_biqbaboplfbrettd7655fr4n2y/node_modules/next-mdx-remote/dist/index.js
var dist = __webpack_require__(7424);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(2740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(4990);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(4250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/chevronRight.js
var chevronRight = __webpack_require__(5109);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(9909);
// EXTERNAL MODULE: ../../packages/ui/src/components/list/list.tsx
var list = __webpack_require__(7782);
// EXTERNAL MODULE: ../../packages/ui/src/styles/common.ts
var common = __webpack_require__(4015);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/side-menu/side-menu.tsx + 4 modules
var side_menu = __webpack_require__(8120);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/side-bar/side-bar.tsx










/**
 * SideBar is used in mobile and desktop views.
 */ function SideBar(param) {
    let { directories , title , className  } = param;
    const hasValidDirectories = directories.length > 0;
    const header = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: title && hasValidDirectories && /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
            as: "h4",
            className: "px-1 pb-4 font-semibold text-gray-1100",
            children: title
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                className: (0,clsx_m/* default */.Z)("sticky top-16 isolate hidden h-[calc(100vh-4rem)] w-full flex-shrink-0 flex-col items-start border-r border-gray-500 pl-4 text-gray-1200 sm:flex md:w-64", className),
                children: [
                    header,
                    hasValidDirectories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full overflow-y-auto pr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Directories, {
                            directories: directories
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                className: "w-full sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(side_menu/* SideMenu */.f, {
                    position: "br",
                    styles: {
                        items: "w-full overflow-y-auto space-y-2 flex-1 pl-6"
                    },
                    fixed: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                            children: header
                        }),
                        directories.map((dir)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full flex-col items-stretch",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryItem, {
                                        directory: dir
                                    })
                                })
                            }, getId(dir)))
                    ]
                })
            })
        ]
    });
}
function Directories(param) {
    let { directories  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        className: "flex-1 space-y-2",
        children: directories.map((dir)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List.Item */.a.Item, {
                hideMarker: true,
                className: "flex w-full flex-col items-stretch",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryItem, {
                    directory: dir
                })
            }, getId(dir)))
    });
}
function DirectoryItem(param) {
    let { directory: dir  } = param;
    const router = (0,next_router.useRouter)();
    const [isOpened, setIsOpened] = react.useState(()=>isButtonActive(dir, router.asPath));
    const listMarker = dir.route ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "mr-3.5 inline-block h-1.5 w-1.5 rounded-full bg-current hover:bg-gray-1200"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
        size: 18,
        className: (0,clsx_m/* default */.Z)("-ml-1.5 mr-2 transition", isOpened && "rotate-90"),
        onClick: (e)=>{
            e.stopPropagation();
            setIsOpened((prev)=>!prev);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dir.route ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                href: dir.route,
                className: (0,clsx_m/* default */.Z)("capitalize", clickableItemStyle, router.asPath === dir.route && activeStyle),
                hideUnderline: true,
                variant: "secondary",
                children: [
                    listMarker,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: dir.title
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (0,clsx_m/* default */.Z)("capitalize", clickableItemStyle),
                type: "button",
                onClick: ()=>setIsOpened((prev)=>!prev),
                "aria-label": "Expand children routes",
                children: [
                    listMarker,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: dir.title
                    })
                ]
            }),
            dir.children && isOpened && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-stretch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-0.5 w-3.5 border-l"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Directories, {
                        directories: dir.children
                    })
                ]
            })
        ]
    });
}
const clickableItemStyle = [
    "flex flex-row items-center justify-start",
    common/* listHoverable */.D6
];
const activeStyle = "bg-primary-500 border border-primary-700 text-primary-1100";
function isButtonActive(dir, pathname) {
    if (dir.route === pathname) {
        return true;
    }
    if (dir.children) {
        for (const child of dir.children){
            if (isButtonActive(child, pathname)) {
                return true;
            }
        }
        return false;
    }
    return false;
}
function getId(dir) {
    return dir.title + (dir.route || "");
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/mdx-components/mdx-components.tsx
var mdx_components = __webpack_require__(1605);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/footer/footer.tsx
var footer = __webpack_require__(5260);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/docs/index.tsx






function Docs(param) {
    let { mdxSource , frontMatter , directories =[] , nearNav  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        title: (frontMatter === null || frontMatter === void 0 ? void 0 : frontMatter.title) || "Docs",
        hideFullBleed: true,
        hideFooter: true,
        styles: {
            container: "py-0 md:mx-0"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex min-h-full flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex min-h-full w-full flex-1 flex-row space-x-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar, {
                        className: "pt-10",
                        directories: directories,
                        title: "Document"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "prose mx-auto overflow-x-hidden pt-10",
                                children: mdxSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, {
                                    ...mdxSource,
                                    components: mdx_components/* MDXComponents */.t
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto flex max-w-[65ch] flex-row justify-between",
                                    children: [
                                        nearNav.prev ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                                            size: "lg",
                                            variant: "plain",
                                            href: nearNav.prev.link,
                                            className: (0,clsx_m/* default */.Z)("flex -translate-x-5 flex-row items-center px-3 py-2 text-gray-1200", common/* listHoverable */.D6),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
                                                    size: 28,
                                                    className: "rotate-180"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: nearNav.prev.title
                                                })
                                            ]
                                        }) : // To fill left empty when there is only 1 next
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        nearNav.next && /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                                            size: "lg",
                                            variant: "plain",
                                            href: nearNav.next.link,
                                            className: (0,clsx_m/* default */.Z)("flex translate-x-5 flex-row items-center px-3 py-2 text-gray-1200", common/* listHoverable */.D6),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: nearNav.next.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronRight/* default */.Z, {
                                                    size: 28,
                                                    className: ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/docs/[[...slug]].tsx
var __N_SSG = true;



/***/ }),

/***/ 1605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MDXComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9909);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6169);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MDXComponents = {
    a: MDXLink,
    pre: Pre
};
function MDXLink(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: props.href || "",
        variant: "solid",
        children: props.children
    });
}
function Pre(param) {
    let { children , className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("not-prose whitespace-normal break-all md:whitespace-pre md:break-words", (_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blockPre), className),
        children: children
    });
}


/***/ }),

/***/ 7782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ List; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);



const variantTags = {
    ordered: "ol",
    unordered: "ul"
};
function List(param) {
    let { className , variant ="unordered" , ...restProps } = param;
    const Tag = variantTags[variant];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex list-none flex-col py-2", className)
    });
}
List.Item = ListItem;
function ListItem(param) {
    let { className , children , styles ={} , hideMarker , ...liProps } = param;
    const ChildrenContainer = typeof children === "string" ? "span" : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        ...liProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center space-x-2 text-gray-1100", className),
        children: [
            !hideMarker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-current", styles.marker)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChildrenContainer, {
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 6169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blockPre":"mdx_blockPre__qYcGw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [166,990,457,740,774,888,179], function() { return __webpack_exec__(6380); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);